import * as fabric from 'office-ui-fabric-react';
import GeneralSettingsDesignDoorScreen from './GeneralSettingsDesignDoorScreen';
import GeneralSettingsDesignInfoScreen from './GeneralSettingsDesignInfoScreen';
import GeneralSettingsDesignTerminal from './GeneralSettingsDesignTerminal';
const GeneralSettingsDesign = () => {
    return (
        <div style={{ textAlign: 'center' }}>
            <fabric.Pivot>
                <fabric.PivotItem headerText="Info ekranai">
                    <GeneralSettingsDesignInfoScreen />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Durų ekranai">
                    <GeneralSettingsDesignDoorScreen />
                </fabric.PivotItem>
                <fabric.PivotItem headerText="Terminalai">
                    <GeneralSettingsDesignTerminal />
                </fabric.PivotItem>
            </fabric.Pivot>
        </div>
    );
};

export default GeneralSettingsDesign;
